/* kitsters-privacy-policy.js - smooth-scroll + scroll-spy for the sticky
   "On this page" nav. The TOC links and their target section ids are both
   rendered server-side from the same block list, so this only wires
   behaviour - it never has to invent anchors. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.kpv');
    if (!root) return;

    var toc = root.querySelector('[data-kpv-toc]');
    if (!toc) return;

    var links = Array.prototype.slice.call(toc.querySelectorAll('[data-kpv-toc-link]'));
    if (!links.length) return;

    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    toc.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', a.getAttribute('href')); }
    });

    if (!('IntersectionObserver' in window)) return;

    var targets = links
      .map(function (a) { return document.getElementById(a.getAttribute('data-kpv-toc-link')); })
      .filter(Boolean);
    if (!targets.length) return;

    var visible = {};
    function setActive() {
      var activeId = null;
      for (var i = 0; i < targets.length; i++) {
        if (visible[targets[i].id]) { activeId = targets[i].id; break; }
      }
      if (!activeId) return;
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('data-kpv-toc-link') === activeId);
      });
    }

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      setActive();
    }, { rootMargin: '-96px 0px -70% 0px' });

    targets.forEach(function (t) { spy.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
